import React from 'react';
import UpVioletImg from '../../assets/images/up-violet.svg';
import UpLoadingBar from '../../components/Common/UpLoadingBar';
import StepIndicator from './StepIndicator';

// One card width on every step, so the card and its progress bar never move.
// Text and forms sit in a readable centred column; `fullWidth` (the signing
// document) renders below it across the whole card.
function AppPage({ step, noPayment = false, loading = false, fullWidth = null, children }) {
  return (
    <div className="signup-page">
      <div className="signup-topbar">
        <img src={UpVioletImg} alt="UrbanPiper" />
      </div>
      <UpLoadingBar loading={loading} />
      <div className="signup-body">
        <div className="signup-card">
          <div className="signup-column">
            {step && <StepIndicator current={step} noPayment={noPayment} />}
            {children}
          </div>
          {fullWidth}
        </div>
      </div>
    </div>
  );
}

export default AppPage;
